export default [
  {
    path: '/',
    view: 'Login',
    title: 'Login',
    dir: 'views/',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/login/:slug?',
    view: 'Login',
    title: 'Login',
    dir: 'views/',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/primeiroacesso',
    view: 'PrimeiroAcesso',
    title: 'Primeiro Acesso',
    dir: 'views/',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/profile',
    view: 'Profile',
    title: 'Perfil',
    dir: 'views/',
    menu: false,
    meta: {
    }
  },
  {
    path: '/solicitacaodetalhe/:id',
    view: 'SolicitacaoDetalhe',
    dir: 'views/operacoes/solicitacao/',
    menu: false,
    meta: {
    }
  },
  {
    path: '/solicitacaodetalhesimples/:id',
    view: 'SolicitacaoDetalheSimples',
    dir: 'views/operacoes/solicitacao/',
    title: 'Solicitação Simples',
    menu: false,
    meta: {
    }
  },
  {
    title: 'Dashboard',
    icon: 'mdi-chart-donut-variant',
    path: '/dashboard',
    view: 'Dashboard',
    dir: 'views/',
    menu: true,
    meta: {
    }
  },
  {
    path: '/cadastros',
    icon: 'mdi-account-cog',
    title: 'Cadastros',
    dir: 'views/cadastros/',
    menu: true,
    meta: {
      allRolesRequired: false
    },
    items: [
      {
        path: '/operadores',
        title: 'Operadores',
        view: 'operador/Operador',
        menu: true,
        meta: {
          roles: ['Consignado.ConsultarOperador'],
          allRolesRequired: false
        }
      },
      {
        path: '/funcionarios',
        title: 'Funcionários',
        view: 'usuario/Usuario',
        menu: true,
        meta: {
          allRolesRequired: false
        }
      },
      {
        path: '/portais',
        title: 'Portais',
        view: 'portal/Portal',
        menu: true,
        meta: {
          roles: ['Consignado.Gerente'],
          allRolesRequired: false
        }
      },
      {
        path: '/empresas',
        title: 'Empresas',
        view: 'empresa/Empresas',
        menu: true,
        meta: {
          allRolesRequired: false
        }
      }
    ]
  },
  {
    path: '/operacoes',
    icon: 'mdi-badge-account-horizontal-outline',
    title: 'Operações',
    dir: 'views/operacoes/',
    menu: true,
    meta: {
      allRolesRequired: false
    },
    items: [
      {
        path: '/solicitacoes',
        title: 'Solicitações',
        view: 'solicitacao/Solicitacoes',
        menu: true,
        meta: {
          allRolesRequired: false
        }
      },
      {
        path: '/relatorioparcelas',
        title: 'Relatório de parcelas',
        view: 'relatorioparcelas/RelatorioParcelas',
        menu: true,
        meta: {
          allRolesRequired: false
        }
      },
      {
        path: '/importacaoliquidacao',
        title: 'Importar liquidações',
        view: 'liquidacao/liquidacoes/Liquidacoes',
        menu: false,
        meta: {
          roles: ['Consignado.BaixarParcelas'],
          allRolesRequired: false
        }
      },
      {
        path: '/lancamentoparcelas',
        title: 'Lançamento de parcelas',
        view: 'liquidacao/lancamentoparcelas/LancamentoParcelas',
        menu: true,
        meta: {
          roles: ['Consignado.BaixarParcelas'],
          allRolesRequired: false
        }
      },
      {
        path: '/Lote',
        title: 'Lote cobrança',
        menu: false,
        meta: {
          allRolesRequired: false
        },
        items: [
          {
            path: '/lotes',
            title: 'Lotes',
            view: 'lotecobranca/lotes/Lotes',
            menu: true,
            meta: {
              allRolesRequired: false
            }
          }
        ]
      },
      {
        path: '/cobrancaconveniadas',
        title: 'Cobrança de conveniadas',
        view: 'lotecobranca/cobrancaconveniadas/CobrancaConveniadas',
        menu: true,
        meta: {
          allRolesRequired: false
        }
      }
    ]
  },
  {
    path: '/redefinirsenha',
    view: 'RedefinirSenha',
    title: 'Redefinir Senha',
    dir: 'views/',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/imprimirLote',
    view: 'ImprimirLote',
    title: 'Imprimir Lote',
    dir: 'views/',
    menu: false,
    meta: {
      anonymousAuth: localStorage.getItem('status') !== null ? localStorage.getItem('status') === 'loggedOut' : true
    }
  },
];
